import React from "react";
import { useTranslation } from "react-i18next";

import classes from "./ContactUs.module.css";

import { getImageByKey } from "../../scripts/getImageByKey";

export default function ContactUs() {
	// Setup translate function
	const { t, i18n } = useTranslation();
	console.log(i18n.languages);

	return (
		<div className={classes.ContactUs}>
			<div className={classes.ContactUsPrimary}>
				<div className={classes.ContactUs_image}>
					<img src={getImageByKey("contactus")} alt="Kotikino" />
				</div>
				<div className={classes.ContactUs_description}>
					<div className={classes.ContactUs_description_Primary}>
						<h4 className="font-700">{t("contactUs.contactUs")}</h4>
						<div className={classes.ContactUs_description_address}>
							<div className={`${classes.ContactUs_description_address_info} font-400`}>
								<div>{"Nordic Content Distribution Oy"}</div>
								<div className={classes.ContactUs_description_address_info_title}>
									{" "}
									{t("contactUs.address")}
								</div>
								<div> Itälahdenkatu 18 A A,</div>
								<div> 00210 Helsinki</div>
							</div>
						</div>

						<div className={classes.ContactUs_description_email}>
							<a
								className={classes.ContactUs_description_email_button}
								href="https://zfrmz.com/fx50DqYMzkbjQ9flTQ91"
								target="_blank"
								rel="noreferrer"
							>
								{t("contactUs.sendEmail")}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
